(function($){
    var settings;
    $.fn.multiFileUploader = function(options) {

        settings = $.extend({appendUploadQueue: appendUploadQueue, detachFromUploadQueue: detachFromUploadQueue, validateSelectedFile: validateSelectedFile, unsupportedFileType: unsupportedFileType}, options||{});

        fileInput = $(this);
        fileInput.bind('change-file', fileSelected);
    };

    function fileSelected(event){

        var fileInput = event.target;
        var $fileInput = $(fileInput);

        if(settings.validateSelectedFile(fileInput))
        {
            $fileInput.attr('style', 'position:absolute; top: -3000px; left: -3000px;');
            $fileInput.addClass('multi-file-uploader-hidden');

            var $newFileInput = $('<input type="file" name="' + $fileInput.attr('name') + '" class="' + $fileInput.attr('class') + '" accept="' + $fileInput.attr('accept') + '" />');
            var id = $fileInput.attr("id");
            var indexOfUnderscore = id.indexOf("_");
            var base_id = indexOfUnderscore > -1 ? id.substring(0, indexOfUnderscore) : id;
            var index = indexOfUnderscore > -1 ? id.substring(indexOfUnderscore + 1) * 1 + 1 : 1;
            $newFileInput.attr("id", base_id + "_" + index);
            $newFileInput.insertAfter($fileInput);
            $newFileInput.bind('change-file', fileSelected);

            settings.appendUploadQueue(fileInput);

            $('.multi-file-uploader-remove').bind('click', deleteFileSelected);
        }
        else {
            settings.unsupportedFileType(fileInput);
            $fileInput.val("");
        }
    }

    function appendUploadQueue(fileInput) {
        if($('#multi-file-uploader-list').size()==0) {
            $(fileInput).parent().parent().append("<div id='multi-file-uploader-list'></div>");
            $('#multi-file-uploader-list').hide();
        }
        list = $('#multi-file-uploader-list');
        listItem = '<p>' + $(fileInput).val() + ' <a class="multi-file-uploader-remove" value="' + $(fileInput).val() + '" >X</a></p>';
        list.append(listItem);

        if(list.attr('style').indexOf('none') >= 0){
            list.show();
        }
    }

    function deleteFileSelected(event){

        fileInput = $(event.target);

        filesAlreadySelected = $('.multi-file-uploader-hidden');
        filesAlreadySelected.each(
            function (){
                if($(this).val() == fileInput.attr('value')){
                    $(this).remove();
                    settings.detachFromUploadQueue(fileInput);
                    return;
                }
            }
        );
    }

    function detachFromUploadQueue(bulkUploaderRemove) {
        bulkUploaderRemove.parent().remove();
        if($('#multi-file-uploader-list').html() == "")
            $('#multi-file-uploader-list').hide();
    }

    function validateSelectedFile(fileInput)
    {
        var accept = $(fileInput).attr("accept");
        if($(fileInput).val() && accept.length > 0)
        {
            var exts = accept.split(",");
            var filePath = $(fileInput).val();
            var ext = filePath.substring(filePath.lastIndexOf(".")+1).toLowerCase();
            return $.inArray(ext, exts) >= 0;
        }
        return true;
    }

    function unsupportedFileType(fileInput)
    {
        alert("The file type you are attempting to upload is unsupported");
    }

})(jQuery);